import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

Vue.use(Vuex)

const ADMIN_ID = "itneK5w26hbJHhUy8puEnk5bAoF3"
const EMAILJS_ID = 'user_9cWWvm7JXSyKjmwNWMLy5'

export const store = new Vuex.Store({
  state: {
    fbError: "",
    setLoading: false,
    handouts: [],
    tracks: [],
    notes: [],
    finalTracks: [],
    students: [],
    lessons: [],
    lessonTimes: {
      weekend:['9:00am - 10:00am', '11:00am - 12:00pm', '1:00pm - 2:00pm', '3:00pm - 4:00pm'],
      weekday: [ '4:00pm - 5:00pm', '5:30 - 6:30pm', '7:00 - 8:00pm']
    },
    disallowedDates: [],
    loadedLessonDate: '',
    loadedStudentName: "",
    loadedSongs: [],
    songlists: [],
    targeted: [],
    loadedSonglist: {},
    greetings: [],
    location: "",
    user: null,
    type: "",
    adminId: ADMIN_ID,
    emailJSId: EMAILJS_ID
  },
  mutations,
  actions,
  getters
})
